// extracted by mini-css-extract-plugin
export default {"root":"Menu_root__7rA72","root__item":"Menu_root__item__BSOs9"};